var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerFour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 47,
    viewBox: "0 0 39 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_8544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 42.2422C18.1644 42.2422 17.8315 42.1118 17.5738 41.8538L6.47315 30.6218C-0.157718 23.9125 -0.157718 12.9929 6.47315 6.28366C9.68658 3.03224 13.9577 1.24219 18.5 1.24219C23.0423 1.24219 27.3134 3.03224 30.5268 6.28366C37.1577 12.9929 37.1577 23.9098 30.5268 30.6218L19.4262 41.8538C19.1711 42.1118 18.8356 42.2422 18.5 42.2422Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 42.2422C18.1644 42.2422 17.8315 42.1118 17.5738 41.8538L6.47315 30.6218C-0.157718 23.9125 -0.157718 12.9929 6.47315 6.28366C9.68658 3.03224 13.9577 1.24219 18.5 1.24219C23.0423 1.24219 27.3134 3.03224 30.5268 6.28366C37.1577 12.9929 37.1577 23.9098 30.5268 30.6218L19.4262 41.8538C19.1711 42.1118 18.8356 42.2422 18.5 42.2422Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6323 24.9678V22.6318L18.6626 11.7383H22.3013V22.5645H24.4351V24.9678H22.3013V28H19.5161V24.9678H11.6323ZM14.6196 22.5645H19.561V15.0625H19.3813L14.6196 22.4521V22.5645Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_8544",
    x: 0,
    y: 0.742188,
    width: 39,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_8544"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_8544",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerFour);
export default __webpack_public_path__ + "static/media/marker_four.5deec7d36efa459cf4a2d58139d4ec5f.svg";
export { ForwardRef as ReactComponent };